export default __webpack_public_path__ + "static/media/depot-teams.2a1f8491.svg";